import React from 'react'
import { listArrow } from 'styles/list'
import _ from 'lodash'
import ThemedSectionList from 'components/atoms/ThemedSectionList'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import ListItem from 'components/atoms/ListItem'
import HelperDate, { dateFormat } from 'utils/helper-date'

const HomeMoreTravelHistoryHistoryScene = () => {
	
	const navigation = useNavigation();
	
	const openDetails = ( item= {} ) => {
		navigation.navigate( AppRoutes.MORE_TRAVEL_HISTORY_DETAIL );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ item.name }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openDetails }
			/>
		)
	}
	
	const dateFrom = HelperDate.date().subtract(2, 'weeks').startOf('week' ).toDate()
	const dateTill = HelperDate.date().subtract(1, 'day').startOf('week' ).toDate()
	
	let list = {};
	for( let loopDate = dateFrom; loopDate < dateTill; loopDate.setDate( loopDate.getDate() + 1 ) ) {
		const loopDateObject = HelperDate.date( loopDate )
		const day = loopDateObject.day()
		
		if( day !== 0 && day !== 6 ) {
			const listKey = loopDateObject.format('YYYY-MM');
			
			if( !_.has( list, listKey ) ) {
				list[ listKey ] = {
					title: loopDateObject.format('MMMM'),
					data: []
				}
			}
			
			list[ listKey ].data.push({
				name: loopDateObject.format( dateFormat.DATE_PRETTY )
			})
		}
	}
	
	return (
		<ThemedSectionList
			sections={ list }
			dividerEnabled={ true }
			renderItem={ renderItem.bind( this ) }
		/>
	)
}

export default HomeMoreTravelHistoryHistoryScene
